module.exports = __webpack_public_path__ + "static/media/logo-supplied.e5887796.png";